import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Box } from 'grommet';
import { defineMessages, injectIntl } from 'react-intl';
import {
    withRouter, Redirect, Route,
} from 'react-router';
import styled from 'styled-components';
import {
    addBreadcrumb as addBreadcrumbAction, removeBreadcrumb as removeBreadcrumbAction,
} from 'esm-web-pro/redux/breadcrumb/actions';
import AdminSideMenuLinks from 'esm-web-pro/components/pages/AdminSideMenuLinks';
import MapsRoutes from 'esm-web-pro/routes/Maps';
import AuditRoutes from 'esm-web-pro/routes/Audit';
import ExportRoutes from 'esm-web-pro/routes/Exports';
import AuthorizationRoutes from 'esm-web-pro/routes/Authorization';
import NetworkRoutes from 'esm-web-pro/routes/Network';
import NomenclaturesRoutes from 'esm-web-pro/routes/Nomenclatures';
import LocksRoutes from 'esm-web-pro/routes/Locks';
import RightShadow from 'esm-web-pro/components/layout/RightShadow';

const AdminPageBox = styled(Box)`
    display: block;
    position: relative;
    box-shadow: inset 10px 0px 10px -5px #e2dfdf;
`;

const MapDispatchToProps = ((dispatch) => (
    bindActionCreators({
        addBreadcrumb: addBreadcrumbAction, removeBreadcrumb: removeBreadcrumbAction,
    }, dispatch))
);

const messages = defineMessages({
    adminPage: {
        id: 'admin-page-title',
        defaultMessage: 'Administration',
    },
});

@injectIntl
@withRouter
@connect(null, MapDispatchToProps)
class AdminPage extends React.Component<Object> {
    // eslint-disable-next-line flowtype/no-types-missing-file-annotation
    componentDidMount(): void {
        const {
            addBreadcrumb, intl: { formatMessage },
        } = this.props;
        addBreadcrumb(formatMessage(messages.adminPage));
    }

    componentWillUnmount() {
        const { removeBreadcrumb, intl: { formatMessage } } = this.props;
        removeBreadcrumb(formatMessage(messages.adminPage));
    }

    render() {
        const { location } = this.props;

        return (
            <Box direction="row">
                <AdminSideMenuLinks location={location} />
                <AdminPageBox
                    // key={location.pathname}
                    width="100%"
                    overflow="auto"
                    background="#f8f8f8"
                >
                    <RightShadow>
                        <Route path="/administration" exact>
                            <Redirect to="/administration/infrastructure/providers" />
                        </Route>
                        <AuthorizationRoutes />
                        <MapsRoutes />
                        <NetworkRoutes />
                        <AuditRoutes />
                        <ExportRoutes />
                        <NomenclaturesRoutes />
                        <LocksRoutes />
                    </RightShadow>
                </AdminPageBox>
            </Box>
        );
    }
}

export default injectIntl(AdminPage);
